import React from 'react';
import HeroImage from '../../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../../components/Constant/cta/CTA";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../../components/Constant/button/Button";
import SEO from "../../../../utils/SEO";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Banking License – Cyprus',
        link: '/banking-license-cyprus',
    },
]

function BankingLicenseSaintLucia () {

    return (
        <main className='main'>

            <SEO
                title="Saint Lucia Banking License | Offshore & Domestic Setup "
                description="Establish domestic or offshore banks in Saint Lucia. Get expert support for ECCB licensing, FSRA compliance, and international banking operations. "
                keywords="Saint Lucia banking license, offshore bank Saint Lucia, domestic bank Saint Lucia, ECCB banking license, FSRA compliance Saint Lucia, international bank Saint Lucia, private bank Saint Lucia, bank setup Caribbean "
                url="/banking-license-saint-lucia"
            />

            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>
                    <h1 className='section-title'>
                        Banking License – Saint Lucia
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish Domestic & Offshore Banks in the Eastern Caribbean
                            </h3>
                            <p className='page-paragraph'>
                                <b>Saint Lucia</b> is a respected <b>offshore and regional banking hub</b> in the <b>Caribbean</b>. <b>Banking licenses</b> are issued under the <b>Banking Act (ECCB)</b> and supervised by the <b>Financial Services Regulatory Authority (FSRA)</b>.
                            </p>

                            <h3 className='page-subtitle'>The jurisdiction offers two categories:</h3>
                            <PageList
                                items={[
                                    {
                                        title: "Domestic Banking License",
                                        paragraph: "Full-service banking for residents and businesses in Saint Lucia and the ECCU",
                                        icon: GoDotFill,
                                    },
                                    {
                                        title: "International Banking License",
                                        paragraph: "Offshore banking for non-resident clients only, offering global wealth management, private banking, and corporate financial services",
                                        icon: GoDotFill,
                                    },
                                ]}
                            />

                            <PageList
                                items={[
                                    {
                                        title: "Domestic Retail & Commercial Banks",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Offshore Private Banks",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Corporate Banking",
                                        icon: GiCheckMark,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Saint Lucia Banking Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Saint Lucia for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "ECCB-Regulated",
                                    paragraph: "Credibility ensured through supervision by the Eastern Caribbean Central Bank.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Two Options",
                                    paragraph: "Onshore (domestic) and offshore (international) banking available.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Business Models",
                                    paragraph: "Supports retail, private, corporate, and investment banking structures.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Neutrality",
                                    paragraph: "Offshore banks are exempt from tax on foreign-sourced income.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Stable Jurisdiction",
                                    paragraph: "Common law legal system with political and economic stability.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of Banking Licenses</h3>
                        <p className='page-subtitle'>1. Domestic Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "Serve residents, local companies, and ECCU clients.", icon: GoDotFill },
                                { paragraph: "Full retail & commercial services: deposits, loans, payments.", icon: GoDotFill },
                                { paragraph: "Strict prudential requirements under ECCB supervision.", icon: GoDotFill },
                                { paragraph: "Capital Requirement: Typically USD 5M+.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. International Banking License (Offshore)</p>
                        <PageList
                            items={[
                                { paragraph: "Serve non-resident individuals and corporates only.", icon: GoDotFill },
                                { title: "Services include:", paragraph: 'Private & corporate banking, Multi-currency accounts, Wealth management & investment services, Trade finance & international transfers', icon: GoDotFill },
                                { paragraph: "Capital Requirement: USD 2M minimum paid-up capital.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Services Permitted Under a Saint Lucia Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Accepting Deposits",
                                    paragraph: "Licensed banks can accept local and international deposits from individuals and corporations.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Issuing Loans, Mortgages, and Credit",
                                    paragraph: "Provide lending, mortgage, and credit facilities to clients.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Multi-Currency Accounts",
                                    paragraph: "Offer accounts in multiple currencies for international clients.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Debit/Credit Card Issuance",
                                    paragraph: "Enable clients with card programs linked to their bank accounts.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Investment and Wealth Management",
                                    paragraph: "Provide investment advisory and portfolio management services.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Trade Finance & Letters of Credit",
                                    paragraph: "Support international trade transactions with credit and guarantees.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Custody of Securities",
                                    paragraph: "Safekeeping and administration of client investment assets.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Saint Lucia Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Reputable Offshore Center",
                                    paragraph: "Saint Lucia is a trusted Caribbean jurisdiction with strong banking governance and reputation.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Dual Options",
                                    paragraph: "Choose between domestic and international banking licenses depending on your business model.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Flexible Banking Services",
                                    paragraph: "Operate as a retail, private, or corporate bank under a single regulatory framework.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Neutrality",
                                    paragraph: "Offshore banks are exempt from local taxation on foreign-sourced income.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regional Gateway",
                                    paragraph: "Gain access to the Eastern Caribbean Currency Union (ECCU) and wider Caribbean financial network.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "9–12 months from pre-application consultation to license approval.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 200,000+ covering legal, compliance, and advisory services.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "Domestic Bank: USD 5M+; International Bank: USD 2M minimum.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Include audits, ongoing compliance, and regulator fees.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Experts in Caribbean Banking Licenses",
                                    paragraph: "Specialized guidance for domestic and international banking licenses in Saint Lucia and the Caribbean.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Support",
                                    paragraph: "Comprehensive assistance with incorporation, license filing, compliance setup, and audits.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking Platform Integrations",
                                    paragraph: "Introductions to core banking software providers, PSPs, and card issuers.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative Advisory",
                                    paragraph: "Strategic insights comparing Saint Lucia with Panama, Mwali, and Cyprus for optimal licensing decisions.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Long-Term Compliance Support",
                                    paragraph: "Ongoing assistance with FSRA/ECCB compliance, reporting, and regulatory updates.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                    </div>


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking to establish a bank in the Caribbean?"
                        description=
                            "<b>Saint Lucia</b> offers <b>domestic and offshore banking licenses</b>, combining <b>flexibility</b>, <b>credibility</b>, and <b>tax efficiency</b>."
                        buttonText="Book a Saint Lucia Banking License Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default BankingLicenseSaintLucia;

const faqData = [
    {
        question: "What is the difference between Domestic and International Banking Licenses?",
        content: [
            { type: "answer", text: "Domestic = local retail/commercial banking. International = offshore-only, serving non-residents." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "USD 5M+ for domestic banks, USD 2M for international (offshore)." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "9–12 months." },
        ],
    },
    {
        question: "Can Saint Lucia banks issue debit/credit cards?",
        content: [
            { type: "answer", text: "Yes — in partnership with Visa, Mastercard, or local issuers." },
        ],
    },
    {
        question: "Is Saint Lucia competitive vs Panama?",
        content: [
            { type: "answer", text: "Yes for offshore banking (lower capital), but Panama has stronger global name recognition." },
        ],
    },
];



const testimonialsData = [
    {
        quote:
            "We obtained an offshore banking license in Saint Lucia. Offshore Advisory managed the FSRA process and helped with compliance.",
        author: "Richard A.",
        role: "Private Banking Founder",
    },
    {
        quote:
            "Saint Lucia gave us access to the Caribbean and global clients with lower capital requirements than Panama.",
        author: "Sophia L.",
        role: "Banking Entrepreneur",
    },
];